import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { MetronomeProvider } from '@ally/metronome-ui';
import { InEmberContext } from '.';
import { noop, RouteInEmberProvider, } from './hooks/useRouteInEmber';
export var EmberBridgeContainer = function (_a) {
    var children = _a.children, _b = _a.routeInEmber, routeInEmber = _b === void 0 ? noop : _b;
    return (React.createElement(BrowserRouter, null,
        React.createElement(MetronomeProvider, null,
            React.createElement(InEmberContext.Provider, { value: true },
                React.createElement(RouteInEmberProvider, { value: routeInEmber },
                    React.createElement(React.Fragment, null, children))))));
};
//# sourceMappingURL=EmberBridgeContainer.js.map